import APP from '../../../main.js'
import AppRecord from './AppRecord.js'

class TransactionRule extends AppRecord {

  get bankName(){
    return this.constructor.employeeStore.banks?.find(bank => bank.id === this.bank_id)?.name
  }
  get transactionType(){
    return this.constructor.employeeStore.event_type_filter.find(event_type => event_type.type === this.transaction_type)?.label
  }
}
export default TransactionRule
